module.exports = __webpack_public_path__ + "img/sidebar_tweet_mobile.a38b8d38.svg";